const uri = (key: String) => {
  let base;
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    base = "http://127.0.0.1:8787/";
  } else {
    base = "https://mrbooks2.dennislibre.workers.dev/"
  }
  return `${base}?key=${key}`
}

export default uri;